import { LivrablePrincipal } from '@shared/models/livrable-principal.enum';

import { Référentiel } from './référentiel.model';
import { Cartographie } from '../../../cartographie/models/cartographie.model';

export interface RéférentielLivrable {
  id: string;
  idLivrable: string;
  nomLivrable: LivrablePrincipal | string;
  cartographie: Cartographie;
  referentiel: Référentiel;
  nomLivrableParent?: string;
  dateEcheance?: Date;
  etat: ÉtatRéférentielLivrable;
  estVerrouille?: boolean;
  indice?: number;
  idParcours?: string;
  nomParcours?: string;
}

export enum ÉtatRéférentielLivrable {
  NON_DEMARRE = 'NonDémarré',
  PRODUCTION_DEMARREE = 'ProductionDémarrée',
  VALIDE_SERVICE_FORMATION = 'ValidéServiceFormation',
  VALIDE_METIER = 'ValidéMétier',
  VALIDE_CDM = 'ValidéCDM',
  NON_CONCERNE = 'NonConcerné',
}

export enum ÉtatRéférentielLivrableNom {
  NON_DEMARRE = 'Non démarré',
  PRODUCTION_DEMARREE = 'Production démarrée',
  VALIDE_SERVICE_FORMATION = 'Validé par le service formation',
  VALIDE_METIER = 'Validé par le métier',
  VALIDE_CDM = 'Validé par le CDM',
  NON_CONCERNE = 'Non concerné',
}
